import { IEmployeeModel } from '@/services/api.service';
import { JobItemType } from '@/common/enumerations';
import { stringCompare } from '@/utilities/string.utils';

export interface IEmployeeListModel {
  gid: string;
  firstName: string;
  lastName: string;
  isDeleted: boolean;
  assignableJobItemTypes: JobItemType[];
  readonly name: string;
}

export class EmployeeListModel implements IEmployeeListModel {
  public gid: string = '';
  public firstName: string = '';
  public lastName: string = '';
  public isDeleted: boolean = false;
  public assignableJobItemTypes: JobItemType[] = [];

  get name() {
    return (this.firstName + ' ' + this.lastName).trim();
  }

  constructor(data?: IEmployeeModel) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property)) {
          (this as any)[property] = (data as any)[property];
        }
      }
    }
  }
}
